module.exports = __webpack_public_path__ + "18c21f1d3a594c6b2a0ff1ed9ae273dc.pdf";